/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { Button, Typography } from "@material-ui/core";
import { EmptyPlaceholder, DraggableList } from "../../../../components";
import DashboardConfigCard from "./DashboardCard";
import { useDashboardUrlConfigs } from "../../../dashboardManager/context/Provider";

/**
 * Configuration screen for OpenSearch Dashboard URLs.
 */
const DashboardsConfig = () => {
	const {
		loading,
		isModified,
		dashboardUrls,
		enableDashboards,
		isInValidForm,
		opensearchDomain,
		addDashboardUrlConfig,
		saveScheduledReportsList,
		clearDashboardConfigChanges,
		reorderDashboardUrls,
	} = useDashboardUrlConfigs();

	const reorderTabs = (tabs) => {
		return tabs.map((t, i) => ({ ...t, sortOrder: i }));
	};

	const dashboardUrlsWithId = dashboardUrls.map((url) => ({ ...url, id: url.reportId }));

	const renderDashboardCards = (
		<DraggableList
			items={dashboardUrlsWithId}
			setItems={(newTabOrder) => {
				reorderDashboardUrls(reorderTabs(newTabOrder));
			}}
			renderItem={(tab, index) => (
				<DashboardConfigCard reportOrder={index} dashboardUrlObj={tab} allDashboardUrlConfigs={dashboardUrls} />
			)}
		/>
	);

	return (
		<>
			<div style={{ minWidth: 820, padding: "15px" }}>
				{enableDashboards ? (
					<div style={{ position: "relative", minHeight: 300, display: "flex", flexDirection: "column" }}>
						<>
							<div className="d-flex justify-content-between my-3">
								<div>
									<h4 style={{ fontWeight: "bold" }}>Dashboards Configuration</h4>
									<span className="text-muted">
										Configure
										{"  "}
										<a href={`https://${opensearchDomain}/_dashboards/app/dashboards`} target="_blank" rel="noreferrer">
											OpenSearch Dashboards
										</a>
										{"  "}
										for providing access to supervisors.
									</span>
								</div>
								<div style={{ paddingRight: "0px" }} className="col-6 d-flex justify-content-end">
									<Button
										variant="outlined"
										disabled={loading}
										style={{ height: 30 }}
										onClick={() => {
											addDashboardUrlConfig();
										}}
									>
										Add Dashboard
									</Button>
									{isModified && (
										<>
											<Button
												className="mx-2"
												variant="outlined"
												style={{ height: 30 }}
												onClick={() => {
													clearDashboardConfigChanges();
												}}
												disabled={loading}
											>
												Cancel
											</Button>
											<Button
												onClick={() => {
													saveScheduledReportsList();
												}}
												disabled={!isModified || isInValidForm || loading}
												variant="contained"
												style={{
													color: "#fff",
													height: 30,
													backgroundColor: !loading && isModified && !isInValidForm ? "#cc1f20" : "#e99e9f",
													borderColor: "#cc1f20",
												}}
											>
												Save
											</Button>
										</>
									)}
								</div>
							</div>
							{loading ? (
								<i
									style={{ left: "50%", position: "absolute", top: "50%" }}
									className="fas fa-spinner loading-spinner spin-animation"
								/>
							) : dashboardUrls.length === 0 ? (
								<EmptyPlaceholder inputStyles={{ margin: "100px 0px" }} message="No Dashboards found." />
							) : (
								<div style={{ flex: 1 }} className="mt-2">
									{dashboardUrls.length !== 0 ? (
										renderDashboardCards
									) : (
										<EmptyPlaceholder message="No Dashboard configuration found." />
									)}
								</div>
							)}
						</>
					</div>
				) : (
					<div>
						<Typography variant="h6" style={{ margin: "10px 0px" }}>
							PACE Dashboards
						</Typography>
						<Typography>PACE dashboards are currently not enabled for this environment.</Typography>
						<Typography>Please contact Perficient's MSO Support to enable the dashboard service.</Typography>
					</div>
				)}
			</div>
		</>
	);
};

export default DashboardsConfig;
